import React, {useEffect, useRef} from 'react';
import {Layout, Panel} from 'shared/components';
import Subnav from '../../Subnav';
import ErroredEmployeesWarning from '../../ErroredEmployeesWarning';

const NmbrPayrollContainer = ({erroredNmbrEmployees}) => {
  const containerRef = useRef(null);

  const loadNmbr = () => {
    if (!window.components) {
      setTimeout(loadNmbr, 100);
    } else {
      const frame = window.components.load('run', containerRef.current);

      frame.ready
        .then(() => console.log('Nmbr Components Run Screen loaded'))
        .catch((err) =>
          console.error('Could not load Nmbr Components Run Screen', err),
        );
    }
  };

  useEffect(() => {
    loadNmbr();
  }, []);

  return (
    <div>
      <Subnav/>
      <Layout>
        <ErroredEmployeesWarning erroredNmbrEmployees={erroredNmbrEmployees}/>
        <Panel>
          <div style={{height: '600px'}} ref={containerRef}></div>
        </Panel>
      </Layout>
    </div>
  );
};

export default NmbrPayrollContainer;
